import React, { useState, useEffect } from "react";
import { Button, Spinner, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { API_URL } from "./config";
import Swal from "sweetalert2";
import XGolifeDashboardComponent from "./components/XGolifeDashboardComponent";

const CloseOpenShift = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openShift, setOpenShift] = useState(null);
  const [fetchingShift, setFetchingShift] = useState(false);

  // Get values from local storage
  const companyId = localStorage.getItem("company_id");
  const branchId = localStorage.getItem("branch_id");
  const operatorId = localStorage.getItem("user_id");
   const [username, setUsername] = useState(localStorage.getItem('userName'));

  useEffect(() => {
    const fetchOpenShift = async () => {
      try {
        setFetchingShift(true);
        const response = await fetch(`${API_URL}/shift/getShiftByCompanyBranchOperatorStatus/${companyId}/${branchId}/${operatorId}/Open`);
        const data = await response.json();
        if (data.length > 0) {
          setOpenShift(data[0]);
        } else {
          setOpenShift(null);
        }
      } catch (error) {
        console.error("Error fetching open shift:", error);
      } finally {
        setFetchingShift(false);
      }
    };

    fetchOpenShift();
  }, [companyId, branchId, operatorId]);

  const handleCloseAndOpenShift = async () => {
    try {
      setLoading(true);

      const getShiftResponse = await fetch(`${API_URL}/shift/getShiftByCompanyBranchOperatorStatus/${companyId}/${branchId}/${operatorId}/Open`);
      const shiftData = await getShiftResponse.json();
      const openShift = shiftData[0];

      if (!openShift) {
        Swal.fire({
          icon: 'warning',
          title: 'No Open Shift Found',
          text: 'There is no open shift to close.',
        });
        setLoading(false);
        return;
      }

      // Close the existing shift
      const closeShiftPayload = {
        shift_status: "Closed",
        date_time_close: new Date().toISOString(),
      };

      await fetch(`${API_URL}/shift/${openShift.shift_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(closeShiftPayload),
      });

      // Open a new shift
      const newShiftPayload = {
        company_id: companyId,
        branch_id: branchId,
        operator_id: operatorId,
        shift_status: "Open",
        date_time_open: new Date().toISOString(),
        date_time_close: "0000-00-00 00:00:00",
        shift_comment: `Opened by ${username}`, // Updated shift_comment
        syncid: Math.random().toString(36).substr(2, 9),
      };

      await fetch(`${API_URL}/shift`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newShiftPayload),
      });

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Shift closed and new shift opened.',
        timer: 2000,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate('/XGolifeDashboard'); 
      }, 2000);

    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while closing and opening shift.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <XGolifeDashboardComponent>
      <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh', paddingTop: '40px', paddingBottom: '40px' }}>
        <div className="container" style={{ maxWidth: '500px' }}>
          <h2 className="mb-4 text-center" style={{ fontWeight: 700, color: '#2c3e50' }}>
            Shift Management
          </h2>

          <Card className="shadow-sm border-0" style={{ borderRadius: '16px' }}>
            <Card.Body className="p-4">
              {fetchingShift ? (
                <div className="text-center py-4">
                  <Spinner animation="border" variant="warning" />
                </div>
              ) : openShift ? (
                <>
                  <div className="mb-4 text-start">
                    <h5 style={{ fontWeight: 600, color: '#444' }}>Open Shift Details</h5>
                    <p className="mt-3" style={{ fontSize: '16px' }}>
                      <strong>Shift ID:</strong> #{openShift.shift_id}<br />
                      <strong>Opened On:</strong> {new Date(openShift.date_time_open).toLocaleString()}<br />
                      <strong>Comment:</strong> {openShift.shift_comment}
                    </p>
                    <span className="badge bg-success p-2" style={{ fontSize: '14px' }}>
                      Status: Open
                    </span>
                  </div>

                  <div className="d-grid gap-2">
                    <Button
                      variant="warning"
                      size="lg"
                      style={{ fontWeight: '600', borderRadius: '12px' }}
                      onClick={handleCloseAndOpenShift}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{' '}
                          Processing...
                        </>
                      ) : (
                        "Close Shift"
                      )}
                    </Button>
                  </div>
                </>
              ) : (
                <div className="text-center py-5">
                  <p className="text-muted">No open shift found.</p>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </XGolifeDashboardComponent>
  );
};

export default CloseOpenShift;